import { cn } from "@/utils/cn";

interface BreadIconProps {
  className?: string;
}

export const BreadIcon = ({ className }: BreadIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
    xmlns="http://www.w3.org/2000/svg"
    className={cn(className)}
  >
    <path
      d="M4.5 10.5C3.70435 10.5 2.94129 10.1839 2.37868 9.62132C1.81607 9.05871 1.5 8.29565 1.5 7.5C1.5 6.70435 1.81607 5.94129 2.37868 5.37868C2.94129 4.81607 3.70435 4.5 4.5 4.5H13.5C14.2956 4.5 15.0587 4.81607 15.6213 5.37868C16.1839 5.94129 16.5 6.70435 16.5 7.5C16.5 8.29565 16.1839 9.05871 15.6213 9.62132C15.0587 10.1839 14.2956 10.5 13.5 10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 4.5H18.75C19.5456 4.5 20.3087 4.81607 20.8713 5.37868C21.4339 5.94129 21.75 6.70435 21.75 7.5C21.75 8.29565 21.4339 9.05871 20.8713 9.62132C20.3087 10.1839 19.5456 10.5 18.75 10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 10.4062V18.75C14.25 18.9489 14.171 19.1397 14.0303 19.2803C13.8897 19.421 13.6989 19.5 13.5 19.5H4.5C4.30109 19.5 4.11032 19.421 3.96967 19.2803C3.82902 19.1397 3.75 18.9489 3.75 18.75V10.4062"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 10.4062V18.75C19.5 18.9489 19.421 19.1397 19.2803 19.2803C19.1397 19.421 18.9489 19.5 18.75 19.5H13.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
